import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue-cookies";
import BootstrapVue from "bootstrap-vue";
import VueAnalytics from "vue-analytics";
import { Observable } from "rxjs";
import VBodyScrollLock from 'v-body-scroll-lock'; //https://github.com/Pixeldenker/vue-body-scroll-lock

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

import Config from "@/config/vueconfig.js";
import Validator from "@/plugins/Validator.js";
import ga from "@/plugins/GA.js";
import BBEnumCampaignType from "@/plugins/BBEnumCampaignType.js";
import RegExp from "@/plugins/RegExp.js";
import Filter from "@/plugins/Filter.js";
import Account from "@/helper/AccountHelper.js";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueClipboard from 'vue-clipboard2'
import "@splidejs/splide/dist/css/splide.min.css";

//blbo config
import BlobService from "@/core/Blob/BlobService";

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true

Vue.use(VueCookies);
Vue.use(Config);
Vue.use(Validator);
Vue.use(ga);
Vue.use(BBEnumCampaignType);
Vue.use(RegExp);
Vue.use(Filter);
Vue.use(BootstrapVue);
Vue.use(VBodyScrollLock);
Vue.use(VueClipboard);

new Vue({
    router,
    store,
    render: h => h(App),
    created: async function() {
        Vue.initFinished = false;

        Vue.use(VueAnalytics, {
            id: Vue.bzbsConfig.bzbsGaId,
            autoTracking: {
                page: false
            }
        });

        this.initAccount();
        this.initFirebaseTracking();
        let blobConfig = await this.apiGetImageConfig()
        if(blobConfig) {
            this.$store.commit("setBlobConfig", blobConfig);
        }
    },
    methods: {
        initAccount: function() {
            Vue.subInitList = [];
            var observInit = new Observable(subscriber => {
                Vue.subInitList.push(subscriber);
            });
            Vue.observInit = observInit;

            observInit.subscribe(() => {
                var profile = Account.getCacheProfile();
                if (profile != null) {
                    var updated_points = profile.updated_points;
                    this.$store.commit("setPoint", updated_points);

                }
            });
           
            Account.initial();
        },
        initFirebaseTracking: function() {
            // tutorial https://razbakov.com/vue-google-firebase-analytics/
            var config = Vue.bzbsConfig.firebase;
            if (config.apiKey) {
                firebase.initializeApp(config);
                firebase.analytics();
                Vue.prototype.$analytics = firebase.analytics();
            }
        },
        apiGetImageConfig: function() {
            var appName = "bioderma";
            var path = "config.json";

            return new Promise((resolve, reject) => {
                BlobService.apiGetBlobByAppNameAndPath(appName, path).subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
            
        },
    }
}).$mount("#app");
